/**
 * @generated SignedSource<<bf8ccc136e2c874b4829a227052f0d99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type StreamSelectLoadAllJumpToQuery$variables = {
  query: string;
};
export type StreamSelectLoadAllJumpToQuery$data = {
  readonly viewer: {
    readonly jumpToSearch: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "Event";
          readonly end: string | null;
          readonly eventUrl: string;
          readonly id: string;
          readonly note: {
            readonly stream: {
              readonly displayName: string;
              readonly id: string;
              readonly isMerged: boolean;
              readonly isShared: boolean;
              readonly latestNote: {
                readonly eventEnd: string | null;
                readonly eventStart: string | null;
                readonly id: string;
                readonly isHistoryPaywalled: boolean;
                readonly isLocked: boolean;
                readonly time: string | null;
              } | null;
              readonly otherUser: {
                readonly id: string;
              } | null;
              readonly type: NoteStreamType;
              readonly url: string | null;
            };
          } | null;
          readonly originalRecurringEventGid: string | null;
          readonly start: string | null;
          readonly title: string;
        } | {
          readonly __typename: "Note";
          readonly stream: {
            readonly displayName: string;
            readonly id: string;
            readonly isMerged: boolean;
            readonly isShared: boolean;
            readonly latestNote: {
              readonly eventEnd: string | null;
              readonly eventStart: string | null;
              readonly id: string;
              readonly isHistoryPaywalled: boolean;
              readonly isLocked: boolean;
              readonly time: string | null;
            } | null;
            readonly otherUser: {
              readonly id: string;
            } | null;
            readonly type: NoteStreamType;
            readonly url: string | null;
          };
        } | {
          readonly __typename: "NoteStream";
          readonly displayName: string;
          readonly id: string;
          readonly isMerged: boolean;
          readonly isShared: boolean;
          readonly latestNote: {
            readonly eventEnd: string | null;
            readonly eventStart: string | null;
            readonly id: string;
            readonly isHistoryPaywalled: boolean;
            readonly isLocked: boolean;
            readonly time: string | null;
          } | null;
          readonly notesCount: number;
          readonly otherUser: {
            readonly id: string;
          } | null;
          readonly type: NoteStreamType;
          readonly url: string | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null;
      } | null>;
    } | null;
  };
};
export type StreamSelectLoadAllJumpToQuery = {
  response: StreamSelectLoadAllJumpToQuery$data;
  variables: StreamSelectLoadAllJumpToQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMerged",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isShared",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Note",
  "kind": "LinkedField",
  "name": "latestNote",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eventEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHistoryPaywalled",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "otherUser",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notesCount",
      "storageKey": null
    },
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/)
  ],
  "type": "NoteStream",
  "abstractKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v14 = [
  (v13/*: any*/)
],
v15 = {
  "kind": "InlineFragment",
  "selections": (v14/*: any*/),
  "type": "Note",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v17 = {
  "alias": "eventUrl",
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalRecurringEventGid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamSelectLoadAllJumpToQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "JumpToResultsConnection",
            "kind": "LinkedField",
            "name": "jumpToSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JumpToResultsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Note",
                            "kind": "LinkedField",
                            "name": "note",
                            "plural": false,
                            "selections": (v14/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "Event",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreamSelectLoadAllJumpToQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "JumpToResultsConnection",
            "kind": "LinkedField",
            "name": "jumpToSearch",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "JumpToResultsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v12/*: any*/),
                      (v15/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Note",
                            "kind": "LinkedField",
                            "name": "note",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Event",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v10/*: any*/),
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47e0beb98a9a30200acd2a7d6ed19696",
    "id": null,
    "metadata": {},
    "name": "StreamSelectLoadAllJumpToQuery",
    "operationKind": "query",
    "text": "query StreamSelectLoadAllJumpToQuery(\n  $query: String!\n) {\n  viewer {\n    jumpToSearch(query: $query) {\n      edges {\n        node {\n          __typename\n          ... on NoteStream {\n            id\n            type\n            isMerged\n            notesCount\n            displayName\n            isShared\n            url\n            latestNote {\n              id\n              time\n              eventStart\n              eventEnd\n              isLocked\n              isHistoryPaywalled\n            }\n            otherUser {\n              id\n            }\n          }\n          ... on Note {\n            stream {\n              id\n              type\n              isMerged\n              displayName\n              isShared\n              url\n              latestNote {\n                id\n                time\n                eventStart\n                eventEnd\n                isLocked\n                isHistoryPaywalled\n              }\n              otherUser {\n                id\n              }\n            }\n          }\n          ... on Event {\n            id\n            title\n            eventUrl: url\n            start\n            end\n            originalRecurringEventGid\n            note {\n              stream {\n                id\n                type\n                isMerged\n                displayName\n                isShared\n                url\n                latestNote {\n                  id\n                  time\n                  eventStart\n                  eventEnd\n                  isLocked\n                  isHistoryPaywalled\n                }\n                otherUser {\n                  id\n                }\n              }\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "21224ef2d234de65327c9a894e2ddb2f";

export default node;
